import { render, staticRenderFns } from "./navigationPartnerold.vue?vue&type=template&id=684356f6&scoped=true"
import script from "./navigationPartnerold.vue?vue&type=script&lang=js"
export * from "./navigationPartnerold.vue?vue&type=script&lang=js"
import style0 from "./navigationPartnerold.vue?vue&type=style&index=0&id=684356f6&prod&lang=less"
import style1 from "./navigationPartnerold.vue?vue&type=style&index=1&id=684356f6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684356f6",
  null
  
)

export default component.exports